export default {
  inject: ['load'],
  data() {
    return {
      allCustomReports: [],
      customReportPaginationList: [],
    };
  },
  methods: {
    getAllCustomReports: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllCustomReports')
        .then(() => {
          if (this.$store.state.customReportModule.successFlag) {
            this.allCustomReports = this.$store.state.customReportModule.allCustomReports;
          } else {
            if (this.$store.state.customReportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllCustomReports();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getListOfCustomReportsWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getCustomReportsWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          title: this.searchText,
        })
        .then(() => {
          if (this.$store.state.customReportModule.successFlag) {
            this.customReportPaginationList = [];
            let temp = this.$store.state.customReportModule.customReports;
            for (let i = 0; i < temp.length; i++) {
              this.customReportPaginationList.push({
                counter: i + 1,
                title: temp[i].title ? temp[i].title : '-',
                note: temp[i].note ? temp[i].note : '-',
                id: temp[i].id,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.customReportModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.customReportModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.customReportModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.customReportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfCustomReportsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    getCustomReportParameterFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getCustomReportParameter', id).then(() => {
        if (this.$store.state.customReportModule.successFlag) {
          let temp = this.$store.state.customReportModule.customReportParameter;
          if (
            this.$route.name == 'customReportAmarItems' ||
            this.$route.name === 'QcCustomReportItem'
          ) {
            this.readyAmarParamter(temp);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.customReportModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getCustomReportParameterFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.customReportModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
